
document.addEventListener('DOMContentLoaded', function () {

  /* =====================================
     SETTINGS
  ===================================== */

  const FREE_VARIANT_ID = 12345678901234; // CHANGE THIS
  const DISCOUNT_CODE = '96JS2D8Y016D';

  const BUY_QTY = 1;
  const FREE_QTY = 2;

  /*
   * Your Shopify qualifying collections
   * Change handles if required
   */
  const QUALIFYING_COLLECTIONS = [
    'mens-wear',
    'new-arrivals',
    'best'
  ];

  let qualifyingProductIds = new Set();
  let updating = false;


  /* =====================================
     GET PRODUCTS FROM COLLECTIONS
  ===================================== */

  async function loadCollectionProducts() {

    for (const handle of QUALIFYING_COLLECTIONS) {

      try {

        const response = await fetch(
          `/collections/${handle}/products.json?limit=250`
        );

        if (!response.ok) continue;

        const data = await response.json();

        if (data.products) {

          data.products.forEach(function (product) {

            qualifyingProductIds.add(
              Number(product.id)
            );

          });

        }

      } catch (error) {

        console.error(
          'Collection loading error:',
          handle,
          error
        );

      }

    }

    console.log(
      'Qualifying products:',
      qualifyingProductIds
    );
  }


  /* =====================================
     GET CART
  ===================================== */

  async function getCart() {

    const response = await fetch(
      '/cart.js',
      {
        cache: 'no-cache'
      }
    );

    return await response.json();
  }


  /* =====================================
     ADD FREE PRODUCTS
  ===================================== */

  async function addFreeProduct(quantity) {

    return fetch('/cart/add.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({

        items: [

          {
            id: FREE_VARIANT_ID,
            quantity: quantity,

            properties: {
              '_free_gift': 'Buy 1 Get 2 Free'
            }
          }

        ]

      })

    });

  }


  /* =====================================
     UPDATE FREE PRODUCT
  ===================================== */

  async function updateFreeProduct(quantity) {

    return fetch('/cart/update.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({

        updates: {
          [FREE_VARIANT_ID]: quantity
        }

      })

    });

  }


  /* =====================================
     APPLY DISCOUNT
  ===================================== */

  async function applyDiscount() {

    try {

      await fetch(
        '/discount/' +
        encodeURIComponent(DISCOUNT_CODE),
        {
          method: 'GET',
          credentials: 'same-origin'
        }
      );

    } catch (error) {

      console.log(
        'Discount apply error:',
        error
      );

    }

  }


  /* =====================================
     BUY 1 GET 2 LOGIC
  ===================================== */

  async function checkBuyGetFree() {

    if (updating) return;

    updating = true;

    try {

      const cart = await getCart();


      /*
       * ONLY PRODUCTS FROM YOUR
       * SPECIFIC COLLECTIONS COUNT
       */

      let qualifyingQty = 0;

      cart.items.forEach(function (item) {

        /*
         * Don't count the free product
         */
        if (
          Number(item.variant_id) ===
          Number(FREE_VARIANT_ID)
        ) {
          return;
        }


        /*
         * Check product belongs to
         * selected collections
         */
        if (
          qualifyingProductIds.has(
            Number(item.product_id)
          )
        ) {

          qualifyingQty += item.quantity;

        }

      });


      /*
       * Find free product
       */

      const freeItem = cart.items.find(function (item) {

        return Number(item.variant_id) ===
          Number(FREE_VARIANT_ID);

      });


      /*
       * BUY 1 = GET 2
       */

      const groups = Math.floor(
        qualifyingQty / BUY_QTY
      );

      const requiredFreeQty =
        groups * FREE_QTY;


      /* =================================
         ADD FREE PRODUCT
      ================================= */

      if (requiredFreeQty > 0) {

        if (!freeItem) {

          await addFreeProduct(
            requiredFreeQty
          );

        }

        else if (
          freeItem.quantity !==
          requiredFreeQty
        ) {

          await updateFreeProduct(
            requiredFreeQty
          );

        }


        /*
         * Apply discount code
         */
        await applyDiscount();

      }


      /* =================================
         REMOVE FREE PRODUCT
      ================================= */

      else {

        if (freeItem) {

          await updateFreeProduct(0);

        }

      }


      /*
       * Refresh Shopify cart drawer
       */

      document.dispatchEvent(
        new CustomEvent('cart:refresh')
      );

    }

    catch (error) {

      console.error(
        'Buy X Get Y Error:',
        error
      );

    }

    finally {

      updating = false;

    }

  }


  /* =====================================
     ADD TO CART
  ===================================== */

  document.addEventListener(
    'submit',
    function (event) {

      const form = event.target;

      if (
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }

      setTimeout(
        checkBuyGetFree,
        1200
      );

    }
  );


  /* =====================================
     ADD TO CART BUTTON
     FOR CART DRAWER / CUSTOM THEMES
  ===================================== */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          'button[name="add"],' +
          '.product-form__submit,' +
          '[name="add"]'
        );

      if (!button) return;

      setTimeout(
        checkBuyGetFree,
        1500
      );

    }
  );


  /* =====================================
     INITIALIZE
  ===================================== */

  async function init() {

    await loadCollectionProducts();

    await checkBuyGetFree();

  }

  init();

});


// car box

(function () {

  const BUNDLE_TOTAL = 3;

  /* ==========================================
     GET CART
  ========================================== */

  async function getCart() {

    try {

      const response = await fetch('/cart.js', {
        cache: 'no-store'
      });

      return await response.json();

    } catch (error) {

      console.error('Cart error:', error);

      return null;
    }
  }


  /* ==========================================
     FIND MINIMOG CART DRAWER
  ========================================== */

  function findCartDrawer() {

    const selectors = [
      '.m-cart-drawer',
      '.m-cart-drawer__wrapper',
      '.m-cart-drawer__inner',
      '[data-cart-drawer]',
      '.cart-drawer'
    ];

    for (const selector of selectors) {

      const element =
        document.querySelector(selector);

      if (element) {
        return element;
      }
    }

    /*
     * Fallback:
     * Find "Your Bundle"
     */
    const elements =
      document.querySelectorAll(
        'h1,h2,h3,h4,h5,h6,div,span,p'
      );

    for (const element of elements) {

      if (
        element.children.length === 0 &&
        element.textContent.trim() === 'Your Bundle'
      ) {

        return element.closest(
          '[class*="drawer"], ' +
          '[class*="cart"], ' +
          '[class*="side"]'
        ) || element.parentElement.parentElement;

      }
    }

    return null;
  }


  /* ==========================================
     CREATE BOX
  ========================================== */

  function createBundleBox() {

    const box =
      document.createElement('div');

    box.className =
      'ct-bundle-progress';

    box.innerHTML = `
      <div class="ct-bundle-progress_head">Shopping Cart</div>
      <div class="ct-bundle-inner"><div class="ct-bundle-progress__header">

        <span class="ct-bundle-progress__title">
          1 / 3 SELECTED
        </span>

        <span class="ct-bundle-progress__message">
          Add 2 more free
        </span>

      </div>

      <div class="ct-bundle-progress__bars">

        <span class="ct-bundle-progress__bar"></span>

        <span class="ct-bundle-progress__bar"></span>

        <span class="ct-bundle-progress__bar"></span>

      </div></div>

    `;

    return box;
  }


  /* ==========================================
     FIND WHERE TO INSERT
  ========================================== */

  function insertBundleBox(drawer) {

    let box =
      drawer.querySelector(
        '.ct-bundle-progress'
      );

    if (box) {
      return box;
    }

    box = createBundleBox();


    /*
     * Try cart drawer content
     */
    const content =
      drawer.querySelector(
        '.m-cart-drawer__body, ' +
        '.m-cart-drawer__main, ' +
        '.m-cart-drawer__content, ' +
        '.m-cart-drawer__items, ' +
        '.m-cart-drawer__inner'
      );


    if (content) {

      content.insertBefore(
        box,
        content.firstElementChild
      );

      return box;
    }


    /*
     * Fallback
     */
    drawer.insertBefore(
      box,
      drawer.firstElementChild
    );

    return box;
  }


  /* ==========================================
     UPDATE TEXT + BARS
  ========================================== */

  function updateBundleBox(box, selected) {

    selected = Math.max(
      0,
      Math.min(
        selected,
        BUNDLE_TOTAL
      )
    );


    const title =
      box.querySelector(
        '.ct-bundle-progress__title'
      );

    const message =
      box.querySelector(
        '.ct-bundle-progress__message'
      );


    const bars =
      box.querySelectorAll(
        '.ct-bundle-progress__bar'
      );


    /*
     * 1 / 3
     */
    if (selected < 3) {

      const remaining =
        BUNDLE_TOTAL - selected;

      title.textContent =
        selected +
        ' / 3 SELECTED';

      message.textContent =
        'Add ' +
        remaining +
        ' more free';

    }


    /*
     * 3 / 3
     */
    else {

      title.textContent =
        'BUNDLE COMPLETE';

      message.textContent =
        'Buy 1 Get 2 FREE applied';

    }


    /*
     * Progress bars
     */
    bars.forEach(
      function (bar, index) {

        if (index < selected) {

          bar.classList.add(
            'active'
          );

        } else {

          bar.classList.remove(
            'active'
          );

        }

      }
    );

  }


  /* ==========================================
     UPDATE
  ========================================== */

  async function updateBundleProgress() {

    const drawer =
      findCartDrawer();

    if (!drawer) {
      return;
    }


    const cart =
      await getCart();

    if (!cart) {
      return;
    }


    /*
     * Total quantity in cart
     *
     * 1 product = 1 selected
     * 2 products = 2 selected
     * 3 products = complete
     */
    let selected = 0;

    cart.items.forEach(function (item) {

      selected +=
        Number(item.quantity);

    });


    /*
     * If empty, remove box
     */
    if (selected <= 0) {

      const oldBox =
        drawer.querySelector(
          '.ct-bundle-progress'
        );

      if (oldBox) {
        oldBox.remove();
      }

      return;
    }


    const box =
      insertBundleBox(drawer);

    updateBundleBox(
      box,
      selected
    );

  }


  /* ==========================================
     CSS INJECT
  ========================================== */

  if (
    !document.getElementById(
      'ct-bundle-progress-css'
    )
  ) {

    const style =
      document.createElement('style');

    style.id =
      'ct-bundle-progress-css';

    style.textContent = `
      .ct-bundle-inner {
    width: calc(100% - 32px);
    margin: 0px 16px 14px;
    padding: 13px 14px;
    box-sizing: border-box;
    border: 1px solid #dedbd5;
    border-radius: 16px;
    background: #faf9f5;
  }
    .ct-bundle-progress .ct-bundle-progress_head {
    font-size: 24px;
    font-weight: 500;
    width: calc(100% - 32px);
    margin: 0 auto 10px;
}
      .ct-bundle-progress__header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        gap: 10px;

        margin-bottom: 10px;
      }

      .ct-bundle-progress__title {
        font-size: 11px;
        line-height: 16px;

        font-weight: 500;

        color: #222;

        white-space: nowrap;
      }

      .ct-bundle-progress__message {
        font-size: 11px;
        line-height: 16px;

        color: #888;

        white-space: nowrap;
      }

      .ct-bundle-progress__bars {
        display: flex;
        gap: 7px;

        width: 100%;
      }

      .ct-bundle-progress__bar {
        display: block;

        height: 6px;

        flex: 1;

        border-radius: 20px;

        background: #dedbd5;

        transition:
          background 0.25s ease;
      }

      .ct-bundle-progress__bar.active {
        background: #ee4722;
      }

    `;

    document.head.appendChild(style);
  }


  /* ==========================================
     CART UPDATE LISTENER
  ========================================== */

  function refreshBundle() {

    setTimeout(
      updateBundleProgress,
      300
    );

    setTimeout(
      updateBundleProgress,
      800
    );

    setTimeout(
      updateBundleProgress,
      1500
    );

  }


  /* ==========================================
     SHOPIFY CART EVENTS
  ========================================== */

  document.addEventListener(
    'cart:refresh',
    refreshBundle
  );

  document.addEventListener(
    'cart:updated',
    refreshBundle
  );

  document.addEventListener(
    'cart:change',
    refreshBundle
  );


  /* ==========================================
     CART ADD
  ========================================== */

  document.addEventListener(
    'submit',
    function (event) {

      const form =
        event.target.closest(
          'form[action*="/cart/add"]'
        );

      if (!form) {
        return;
      }

      refreshBundle();

    },
    true
  );


  /* ==========================================
     OBSERVE MINIMOG CART DRAWER
  ========================================== */

  let observerTimer;

  const observer =
    new MutationObserver(
      function () {

        clearTimeout(
          observerTimer
        );

        observerTimer =
          setTimeout(
            updateBundleProgress,
            300
          );

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  /* ==========================================
     INITIAL
  ========================================== */

  setTimeout(
    updateBundleProgress,
    500
  );


})();



// ----------------------------------------

document.addEventListener('DOMContentLoaded', function () {

  const FREE_VARIANT_ID = 12345678901234;
  const DISCOUNT_CODE = '96JS2D8Y016';

  const BUY_QTY = 1;
  const FREE_QTY = 2;

  const QUALIFYING_COLLECTIONS = [
    'mens-wear',
    'new-arrivals',
    'best'
  ];

  let qualifyingProductIds = new Set();
  let pdpUpdating = false;


  /* ==========================================
     LOAD QUALIFYING PRODUCTS
  ========================================== */

  async function loadPDPCollections() {

    for (const handle of QUALIFYING_COLLECTIONS) {

      try {

        const response = await fetch(
          `/collections/${handle}/products.json?limit=250`
        );

        if (!response.ok) continue;

        const data = await response.json();

        if (data.products) {

          data.products.forEach(function (product) {

            qualifyingProductIds.add(
              Number(product.id)
            );

          });

        }

      } catch (error) {

        console.error(
          'PDP collection error:',
          handle,
          error
        );

      }

    }

  }


  /* ==========================================
     CART
  ========================================== */

  async function getPDPCart() {

    const response = await fetch('/cart.js', {
      cache: 'no-store'
    });

    return await response.json();

  }


  /* ==========================================
     ADD CURRENT PRODUCT
  ========================================== */

  async function addCurrentProduct(form) {

    const formData = new FormData(form);

    const response = await fetch('/cart/add.js', {

      method: 'POST',

      headers: {
        'Accept': 'application/json'
      },

      body: formData

    });

    if (!response.ok) {

      throw new Error('Product could not be added');

    }

    return await response.json();

  }


  /* ==========================================
     ADD FREE PRODUCT
  ========================================== */

  async function addFreeProduct(quantity) {

    return fetch('/cart/add.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({

        items: [

          {
            id: FREE_VARIANT_ID,
            quantity: quantity,

            properties: {
              '_free_gift': 'Buy 1 Get 2 Free'
            }

          }

        ]

      })

    });

  }


  /* ==========================================
     UPDATE FREE PRODUCT
  ========================================== */

  async function updateFreeProduct(quantity) {

    return fetch('/cart/update.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({

        updates: {
          [FREE_VARIANT_ID]: quantity
        }

      })

    });

  }


  /* ==========================================
     DISCOUNT
  ========================================== */

  async function applyDiscount() {

    try {

      await fetch(
        '/discount/' +
        encodeURIComponent(DISCOUNT_CODE),
        {
          method: 'GET',
          credentials: 'same-origin'
        }
      );

    } catch (error) {

      console.error(
        'Discount error:',
        error
      );

    }

  }


  /* ==========================================
     UPDATE BUY 1 GET 2
  ========================================== */

  async function updatePDPBundle() {

    if (pdpUpdating) return;

    pdpUpdating = true;

    try {

      const cart = await getPDPCart();

      let qualifyingQty = 0;

      cart.items.forEach(function (item) {

        /* Don't count free variant */

        if (
          Number(item.variant_id) ===
          Number(FREE_VARIANT_ID)
        ) {
          return;
        }

        /* Only qualifying products */

        if (
          qualifyingProductIds.has(
            Number(item.product_id)
          )
        ) {

          qualifyingQty += Number(item.quantity);

        }

      });


      const freeItem = cart.items.find(function (item) {

        return Number(item.variant_id) ===
          Number(FREE_VARIANT_ID);

      });


      /* BUY 1 GET 2 */

      const groups = Math.floor(
        qualifyingQty / BUY_QTY
      );

      const requiredFreeQty =
        groups * FREE_QTY;


      if (requiredFreeQty > 0) {

        if (!freeItem) {

          await addFreeProduct(
            requiredFreeQty
          );

        }

        else if (
          freeItem.quantity !==
          requiredFreeQty
        ) {

          await updateFreeProduct(
            requiredFreeQty
          );

        }

        await applyDiscount();

      }

      else {

        if (freeItem) {

          await updateFreeProduct(0);

        }

      }


      /* Update PDP UI */

      updatePDPProgress(qualifyingQty);


      /* Refresh Minimong */

      document.dispatchEvent(
        new CustomEvent('cart:refresh')
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated')
      );

    }

    catch (error) {

      console.error(
        'PDP Buy X Get Y error:',
        error
      );

    }

    finally {

      pdpUpdating = false;

    }

  }


  /* ==========================================
     UPDATE PDP PROGRESS
  ========================================== */

  function updatePDPProgress(selected) {

    const box =
      document.querySelector(
        '.ct-pdp-bundle'
      );

    if (!box) return;


    selected = Math.max(
      0,
      Math.min(selected, 3)
    );


    const title =
      box.querySelector(
        '.ct-pdp-selected'
      );

    const message =
      box.querySelector(
        '.ct-pdp-message'
      );

    const bottom =
      box.querySelector(
        '.ct-pdp-bottom-message'
      );

    const bars =
      box.querySelectorAll(
        '.ct-pdp-progress__bars span'
      );


    if (selected < 3) {

      const remaining =
        3 - selected;

      title.textContent =
        selected +
        ' / 3 SELECTED';

      message.textContent =
        'Add ' +
        remaining +
        ' more free';

      bottom.textContent =
        'Choose ' +
        remaining +
        ' more free product(s)';

    }

    else {

      title.textContent =
        'BUNDLE COMPLETE';

      message.textContent =
        'Buy 1 Get 2 FREE applied';

      bottom.textContent =
        'Buy 1 Get 2 FREE applied';

    }


    bars.forEach(function (bar, index) {

      if (index < selected) {

        bar.classList.add('active');

      } else {

        bar.classList.remove('active');

      }

    });

  }


  /* ==========================================
     START YOUR BUNDLE
  ========================================== */

  document.addEventListener(
    'click',
    async function (event) {

      const button =
        event.target.closest(
          '.ct-pdp-start-bundle'
        );

      if (!button) return;


      const form =
        document.querySelector(
          'form[action*="/cart/add"]'
        );

      if (!form) {

        console.error(
          'Product form not found'
        );

        return;

      }


      button.disabled = true;

      button.classList.add(
        'ct-loading'
      );

      const oldText =
        button.textContent;

      button.textContent =
        'Adding to bundle...';


      try {

        /* Add current product */

        await addCurrentProduct(form);

        /* Run same Buy 1 Get 2 logic */

        await updatePDPBundle();


        button.textContent =
          'Bundle Added ✓';


        setTimeout(function () {

          button.textContent =
            oldText;

          button.disabled = false;

          button.classList.remove(
            'ct-loading'
          );

        }, 1200);


      } catch (error) {

        console.error(error);

        button.textContent =
          'Try Again';

        button.disabled = false;

      }

    }
  );


  /* ==========================================
     NORMAL ADD TO CART
  ========================================== */

  document.addEventListener(
    'submit',
    function (event) {

      const form =
        event.target.closest(
          'form[action*="/cart/add"]'
        );

      if (!form) return;


      setTimeout(
        updatePDPBundle,
        1200
      );

    }
  );


  /* ==========================================
     INIT
  ========================================== */

  async function initPDPBundle() {

    await loadPDPCollections();

    await updatePDPBundle();

  }


  initPDPBundle();

});